import React, { useCallback } from 'react';
import { useProviderHelpers } from './ProviderHelpers';
import moment from 'moment';
import _ from 'lodash';

const Context = React.createContext();

export const LedgerProvider = ({ children }) => {
    const { data, execute, clearData } = useProviderHelpers();

    const selectRecord = useCallback(async (props) => {
        await execute({ scope: 'select', url: `FranchiseLedger/${props.ledgerId}`, method: 'GET', secure: true });
    }, [execute]);

    const newRecord = useCallback(async (props) => {
        await execute({ scope: 'new', payload: { status: 200, body: props } });
    }, [execute]);

    const createRecord = useCallback(async (props) => {
        const entryType = (props.entryTypeId === '30') ? 'Debit' : 'Credit';
        
        props.description = `(Adjustment) ${props.description}`;
        
        if (entryType === 'Debit') {
            props.debit = parseFloat(props.amount);
            props.credit = 0;
        } else {
            props.debit = 0;
            props.credit = parseFloat(props.amount);
        }

        await execute({ scope: 'create', url: `FranchiseLedger/Franchise/${props.franchiseId}/${entryType}`, method: 'POST', payload: props, secure: true });
    }, [execute]);

    const listRecords = useCallback(async (props) => {
        const startDate = (_.isEmpty(props.startDate)) ? moment().startOf('month').format('MM-DD-YYYY') : moment(props.startDate).format('MM-DD-YYYY');

        await execute({ scope: 'list', url: `FranchiseLedger/Franchise/${props.franchiseId}?startDate=${startDate}`, method: 'GET', secure: true });
    }, [execute]);  

    const value = { selectRecord, newRecord, createRecord, listRecords, data, clearData };

    return (
        <Context.Provider value={value}>
            {children}
        </Context.Provider>
    );
};

export const useLedgerStore = () => React.useContext(Context);
